'use client'

import { useTranslations } from 'next-intl'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBell } from '@fortawesome/pro-solid-svg-icons'

import NotificationsBellPublic from './NotificationBellPublic/NotificationBellPublic'
import ArrivalPortDisplay from './ArrivalPortDisplay'
import DiscoverSmartAlertButton from './DiscoverSmartAlertButton'
import SeeAllEventLink from './SeeAllEventLink'

import { TVesselJourneyResponse } from '@/api/v1/resources/vesselJourney'

import './NotificationsPublic.scss'

type TProps = {
  vessel: TVesselJourneyResponse
}

function NotificationsPublicClient({ vessel }: TProps) {
  const t = useTranslations('Notifications')

  return (
    <div className="notifications-public">
      <div className="title">
        <h3 className="notifications-public__title">
          <FontAwesomeIcon icon={faBell} />
          <span>{t('notification')}</span>
        </h3>
        <DiscoverSmartAlertButton />
      </div>
      <div className="notification-item">
        <div className="notification-name">
          <label>{t('arriveAtFirstBerth')}</label>
          <ArrivalPortDisplay />
        </div>
        <NotificationsBellPublic toggled={false} vesselImo={vessel.ship.imo} />
      </div>
      <div className="notification-item">
        <div className="notification-name">
          <label>{t('bunkerAlongside')}</label>
          <ArrivalPortDisplay />
        </div>
        <NotificationsBellPublic toggled={false} vesselImo={vessel.ship.imo} />
      </div>
      <SeeAllEventLink />
    </div>
  )
}

export default NotificationsPublicClient
